import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import cssUrl from '../components/cssUrl';

/** 事例一覧ページのカード。写真 16:10 + 明朝タイトル + 補助テキスト。 */
const CardComp = (props) => {
  return (
    <Box
      component="a"
      href={props.url}
      sx={{ display: 'block', color: 'inherit', textDecoration: 'none', textAlign: 'left' }}
    >
      <Box sx={{ aspectRatio: '16 / 10', overflow: 'hidden', bgcolor: 'kinari' }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: cssUrl(props.img_path),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transition: 'transform .5s ease',
            'a:hover &': { transform: 'scale(1.05)' },
          }}
        />
      </Box>
      <Typography variant="h3" component="h3" sx={{ fontSize: 20, letterSpacing: '.12em', mt: 3, mb: 1 }}>
        {props.title}
      </Typography>
      {props.message ? (
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>{props.message}</Typography>
      ) : null}
    </Box>
  );
};

export default CardComp;
